import React, { useState, useEffect, useRef } from "react";
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Button,
    Paper,
    Box,
    Typography,
    TableSortLabel,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import RewardsFilterPopup from "../RewardsPointsBook/RewardsFilterPopup";
import PaginationComponent from "../../brands/Pagination";

import DropDownFilter, { Option } from "./DropDownFilter";
import Export from "../../../../src/assests/images/export.svg";
import Sorting from "../../../../src/assests/images/Sorting.svg";
import BulkUploadFilter from "./BulkuploadFilter";
import { getExportRetailers } from '../../reports/api'
import { getToken } from "../../../utils/utils";


// Column dropdown options
const columns: Option[] = [
    { label: "User ID", value: "userId" },
    { label: "PMI Entity Code", value: "pmi_entity_code" },
    { label: "Retailer Name", value: "retailer_name" },
    { label: "Outlet Name", value: "outlet_name" },
    { label: "Phone Number", value: "phone_number" },
    { label: "Locations", value: "locations" },
    { label: "Outlet Type", value: "outlet_type" },
    { label: "Member Since", value: "member_Since" },
    { label: "Current Points", value: "Current_points" },
    { label: "Total Lifetime Points", value: "Total_lifetime_points" },
    { label: "Total Redeemed Points", value: "Total_Redeemed_Points" },
    { label: "Last Redemption Date", value: "Last_redeemption_date" },
    { label: "Tasks Given", value: "Tasks_given" },
    { label: "Tasks Completed", value: "Tasks_completed" },
    { label: "Current Active Tasks", value: "Current_active_tasks" },
    { label: "Current Active Tasks Completed", value: "Current_active_tasks_completed" },
    { label: "No of Task", value: "no_of_task" },                         // 👈 NEW
    { label: "Remaining Points", value: "remaining_points" },             // 👈 NEW
    { label: "Remaining/Total Points", value: "remaining_points/total_points" },
    { label: "Total Points", value: "totalpoints" },
    { label: "Last Login", value: "last_login" },
    { label: "ASM Name", value: 'asm_name' },
    { label: "TSE Name", value: 'tse_name' },
    { label: "Area Code", value: 'area_code' },
    { label: "Territory Code", value: 'territory_code' },
    { label: "SFA ID", value: 'sfa_id' },
    { label: "Outlet Salesforce ID", value: 'outlet_salesforce_id' },
    { label: "Contracted Since", value: 'contract_since' },
    { label: "Current Rental Value", value: 'current_rental_value' },
    { label: "Region", value: 'region' },
    {label:"Territory ID",value:'territory_id'},
    {label:'DTE Retailer',value:'dte_retailer'},
    {label:'Top Retailer',value:'top_retailer'},
    {label:'Status',value:'status'},

];


// Interfaces
export interface RewardPointResponse {
    userId: string;
    pmi_entity_code: string;              // mapped from userId
    retailer_name: string;
    outlet_name: string;
    phone_number: string;             // mapped from phone_number
    locations: string;
    outlet_type: string;
    member_Since: string;
    Current_points: number;
    Total_lifetime_points: number;
    Total_Redeemed_Points: number;
    Last_redeemption_date: string | null;  // mapped from Last_redeemption_date
    Tasks_given: number;
    Tasks_completed: number;
    Current_active_tasks: number;
    Current_active_tasks_completed: number;
    no_of_task: number;
    remaining_points: number;
    ["remaining_points/total_points"]: string; // mapped from remaining_points/total_points
    totalpoints: number;
    last_login: string;
    asm_name: string;
    tse_name: string;
    territory_code: string;
    area_code: string;
    outlet_salesforce_id: string;
    sfa_id: string;
    current_rental_value: string;
    contract_since: string,
    region: string,
    territory_id:string,
    status:string
    // 👈 not in JSON, keep optional
}



interface BulkRetailerTableProps {
    data: RewardPointResponse[];
    totalUsers?: number;
    page: number;             // ⭐ CHANGED
    setPage: (p: number) => void; // ⭐ CHANGED
    limit: number;
    search: string;
    startDate: string;
    endDate: string;
}
const defaultColumns = [
    "userId",
    "pmi_entity_code",
    "retailer_name",
    "locations",
    "outlet_type",
    "member_Since",
    "phone_number",
    "Current_points",
    "last_login",
    "Total_lifetime_points",
    "status"
]

const BulkRetailerTable: React.FC<BulkRetailerTableProps> = ({ data, totalUsers, page, setPage, limit, startDate, endDate, search }) => {
    const [users, setUsers] = useState<RewardPointResponse[]>([]);
    const [isPopupVisible, setIsPopupVisible] = useState(false);
    const popupRef = useRef<HTMLDivElement | null>(null);

    const [selectedCols, setSelectedCols] = useState<string[]>(defaultColumns)

    const [orderBy, setOrderBy] = useState<keyof RewardPointResponse>("userId");
    const [order, setOrder] = useState<"asc" | "desc">("asc");
    const [appliedFilters, setAppliedFilters] = useState<any>({
        locations: [],
        outlet_type: [],
        lastLogin: "",
        startDate: "",
        endDate: "",
        search: ""

    })

    const token = getToken();
    const handleExport = async () => {
        try {

            const reqBody = {
                ...appliedFilters,
                search: search || "",
                startDate: startDate,
                endDate: endDate,
                columns: selectedCols,
            };
            console.log("Export request body >>>", reqBody);
            const response = await getExportRetailers(reqBody, token);

            // 👉 Create blob link to download
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "retailers_export.xlsx"); // 👈 set filename
            document.body.appendChild(link);
            link.click();
            link.remove();
        } catch (error) {
            console.error("Export failed:", error);
        }
    };
    const buttonRef = useRef<HTMLButtonElement>(null);

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (
                popupRef.current &&
                !popupRef.current.contains(event.target as Node) &&
                buttonRef.current &&
                !buttonRef.current.contains(event.target as Node)
            ) {
                setIsPopupVisible(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    useEffect(() => {
        setUsers(data);
    }, [data]);



    // // Sorting logic
    // const handleSort = (property: keyof RewardPointResponse) => {
    //     const isAsc = orderBy === property && order === "asc";
    //     setOrder(isAsc ? "desc" : "asc");
    //     setOrderBy(property);
    // };

    // const sortedUsers = [...users].sort((a, b) => {
    //     let aVal = a[orderBy] ?? ""; // normalize null to empty string
    //     let bVal = b[orderBy] ?? "";
    //      if (orderBy === "userId") {
    //             aVal = Number(aVal);
    //             bVal = Number(bVal);
    //         }

    //     if (aVal < bVal) return order === "asc" ? -1 : 1;
    //     if (aVal > bVal) return order === "asc" ? 1 : -1;
    //     return 0;
    // });

    // const paginatedUsers = users || [];
    // const paginatedUsers = (data|| []).slice((page - 1) * limit, page * limit);
    const handleSort = (property: keyof RewardPointResponse) => {
        const isAsc = orderBy === property && order === "asc";
        setOrder(isAsc ? "desc" : "asc");
        setOrderBy(property);
    };

    // ⭐ NEW: Apply sorting to users
    const sortedUsers = [...users].sort((a, b) => {
        let aVal = a[orderBy] ?? "";
        let bVal = b[orderBy] ?? "";

        // convert numeric-like strings to numbers
        if (!isNaN(Number(aVal)) && !isNaN(Number(bVal))) {
            aVal = Number(aVal);
            bVal = Number(bVal);
        }

        if (aVal < bVal) return order === "asc" ? -1 : 1;
        if (aVal > bVal) return order === "asc" ? 1 : -1;
        return 0;
    });

    // ⭐ CHANGED: use sortedUsers instead of users directly
    const paginatedUsers = sortedUsers || [];


    return (
        <Box sx={{ background: "#fff", borderRadius: "10px", border: "1px solid #cfcfcf" }}>
            {/* Header with filters */}
            <Box
                sx={{
                    padding: "25px ",
                    display: "flex",
                    justifyContent: "space-between",
                }}
            >
                <Typography sx={{ fontSize: "16px", fontWeight: "600", marginTop: "10px" }}>
                    Retailers  Total {totalUsers} Users
                </Typography>
                <Box sx={{ display: "flex" }}>
                    <Box sx={{ width: "240px", marginRight: "20px" }}>
                        <DropDownFilter
                            placeholder="Select columns"
                            options={columns}
                            value={selectedCols}
                            onChange={(cols) => {
                                console.log('select all clicked...........')
                                if (cols.includes("ALL")) { // ⭐ handle Select All click
                                    if (selectedCols.length === columns.length) {
                                        setSelectedCols(defaultColumns); // deselect → reset default
                                    } else {
                                        setSelectedCols(columns.map(c => c.value)); // select all
                                    }
                                } else if (cols.length === 0) {
                                    setSelectedCols(defaultColumns); // ⭐ empty → reset default
                                } else {
                                    setSelectedCols(cols);
                                }
                            }}

                        />
                    </Box>
                    <Box sx={{ position: "relative", display: "inline-block" }}>
                        <Button
                            ref={buttonRef}

                            variant="contained"
                            onClick={() => setIsPopupVisible((prev) => !prev)}
                            sx={{
                                textTransform: "capitalize",
                                backgroundColor: "#fff",
                                height: "44px",
                                padding: "7px 12px",
                                borderRadius: "10px",
                                color: "#000",
                                border: "1px solid #DEDEDE",
                                boxShadow: "none",
                                marginRight: "20px",
                                "&:hover": { backgroundColor: "#fff", boxShadow: "0px 0px 5px 0px #696969ff", },
                            }}
                            endIcon={<ExpandMoreIcon
                                sx={{
                                    fontSize: "30px",
                                    transition: "transform 0.3s",
                                    transform: isPopupVisible ? "rotate(180deg)" : "rotate(0deg)", // 👈 rotates arrow
                                }}
                            />}
                        >
                            Filters
                        </Button>
                        {isPopupVisible && (
                            <div ref={popupRef} style={{
                                position: "absolute",
                                top: "100%", // 👈 positions just below button
                                right: 0, // align right with button

                                zIndex: 9999,
                            }}>
                                <BulkUploadFilter
                                    appliedFilters={appliedFilters}

                                    onApply={(filters) => {
                                        console.log("Applied filters:", filters);
                                        const newFilters = {
                                            ...filters,
                                            search: search?.trim() || "", // ✅ include search in filters
                                        };
                                        setAppliedFilters(newFilters);
                                        setIsPopupVisible(false);

                                        // 🚀 Send filters to parent
                                        // You should lift this handler up from parent instead of setting here
                                        if (typeof window !== "undefined") {
                                            const event = new CustomEvent("filtersApplied", {
                                                detail: newFilters,
                                            });
                                            window.dispatchEvent(event);
                                        }
                                    }}
                                    onClearAll={() => {
                                        const resetFilters = {
                                            locations: [],
                                            outlet_type: [],
                                            lastLogin: "",
                                            startDate: "",
                                            endDate: "",
                                            search: "",
                                        };
                                        setAppliedFilters(resetFilters);
                                        // 🔹 popup remains open
                                        const event = new CustomEvent("filtersApplied", { detail: resetFilters });
                                        window.dispatchEvent(event);
                                    }}

                                />

                            </div>
                        )}
                    </Box>
                    <Button
                        variant="contained"
                        sx={{
                            textTransform: "capitalize",
                            backgroundColor: "#fff",
                            fontSize: "14px",
                            fontWeight: "500",
                            height: "40px",
                            padding: "16px",
                            borderRadius: "10px",
                            color: "#C8172F",
                            border: "1px solid #C8172F",
                            boxShadow: "none",
                        }}
                        startIcon={<img src={Export} alt="export" />}
                        onClick={handleExport}
                    >
                        Export CSV
                    </Button>
                </Box>
            </Box>

            {/* Table */}
            <Box>
                <TableContainer component={Paper} sx={{ boxShadow: "none" }}>
                    <Table>
                        <TableHead sx={{ background: "#EEF4FF" }}>
                            {/* <TableRow>
                                {columns.map((col) => (
                                    <TableCell key={col.value}>
                                        <TableSortLabel
                                            active={orderBy === col.value}
                                            direction={orderBy === col.value ? order : "asc"}
                                            onClick={() => handleSort(col.value as keyof RewardPointResponse)}
                                            IconComponent={() => (
                                                <img
                                                    src={order === "asc" ? Sorting : Sorting}
                                                    alt="sort"
                                                    style={{ width: 16, height: 16 }}
                                                />
                                            )}
                                        >
                                            {col.label}
                                        </TableSortLabel>
                                    </TableCell>
                                ))}
                            </TableRow> */}
                            <TableRow>
                                {/* ⭐ Render only selected columns */}
                                {columns
                                    .filter((col) => selectedCols.includes(col.value))
                                    .map((col) => (
                                        <TableCell key={col.value}>
                                            <TableSortLabel
                                                active={orderBy === col.value}
                                                direction={orderBy === col.value ? order : "asc"}
                                                onClick={() =>
                                                    handleSort(col.value as keyof RewardPointResponse)
                                                }
                                                IconComponent={() => (
                                                    <img
                                                        src={Sorting}
                                                        alt="sort"
                                                        style={{ width: 16, height: 16 }}
                                                    />
                                                )}
                                            >
                                                {col.label}
                                            </TableSortLabel>
                                        </TableCell>
                                    ))}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {paginatedUsers.length > 0 ? (
                                paginatedUsers.map((user, idx) => (
                                    <TableRow key={idx}>
                                        {/* ⭐ Show only selected fields */}
                                        {columns
                                            .filter((col) => selectedCols.includes(col.value))
                                            .map((col) => (
                                                <TableCell key={col.value}  sx={{
                                                        whiteSpace: "nowrap",   // 👈 prevents wrapping
                                                        
                                                    }}>
                                                     
                                                    {
                                                        // @ts-ignore safe lookup
                                                        user[col.value] ?? "-"
                                                    }
                                                </TableCell>
                                            ))}
                                    </TableRow>
                                ))
                            ) : (
                                <TableRow>
                                    <TableCell colSpan={selectedCols.length || columns.length} align="center">
                                        No Data Found
                                    </TableCell>
                                </TableRow>
                            )}
                        </TableBody>

                    </Table>
                </TableContainer>
            </Box>



            {/* Pagination */}
            <PaginationComponent
                page={page}
                limit={limit}
                totalPages={Math.ceil((totalUsers || 0) / limit)}
                setPage={setPage}
            />
        </Box >
    );
};

export default BulkRetailerTable;
